import { Pipe, PipeTransform } from '@angular/core';
import { RoleGroup, roleGroupDescription } from '../types/auth/role-group';

@Pipe({
  name: 'roleGroup'
})
export class RoleGroupPipe implements PipeTransform {

  transform(value: RoleGroup | undefined, ...args: any[]): string {
    return roleGroupDescription(value!);
  }

}
